

/* @ngInject */ 
export default function() {
	return {
		restrict: 'A',
		require: 'ngModel',
		link: CompareWithLink
	};

	function CompareWithLink(scope, element, attrs, ctrl) {
		var $element = $(element);
		var otherInputName = $element.attr('compare-with');
		if (!otherInputName) {
			throw 'compare-with must set the name of the field to be compared with.';
		}

		var form = $element.closest('form');
		var $form = $(form);
		var otherInput = $("input[name='" + otherInputName + "']", $form);
		var $otherInput = $(otherInput);

		function customValidator(ngModelValue) {
			var isValid = ngModelValue === $otherInput.val();
			ctrl.$setValidity('compare', isValid);
			return isValid;
		}

		ctrl.$parsers.push(customValidator);
	}
}
